module.exports = __webpack_public_path__ + "static/media/Housekeeper.aefd8cb1.svg";